import { Tabs } from "antd";
import { ChargesPage } from "./charges";
import { CategoriesPage } from "./categories";

const CataloguePage = () => {
  const { TabPane } = Tabs;

  return (
    <>
      <Tabs defaultActiveKey="1" tabPosition="left">
        <TabPane
          tab={
            <span>
              <i className="bi bi-list-stars me-2" /> Categories
            </span>
          }
          key="1">
          <CategoriesPage />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="bi bi-cash-coin me-2" /> Charges
            </span>
          }
          key="2">
          <ChargesPage />
        </TabPane>
      </Tabs>
    </>
  );
};

export { CataloguePage };
